// © Microsoft Corporation. All rights reserved.

export enum ExperienceCompositionTypes {
    grid = "grid",
    horizontalStack = "horizontalStack",
    layout = "layout",
    verticalStack = "verticalStack",
    customExperience = "customExperience"
}
